import React from "react";
import PropTypes from "prop-types";
import I18N from "../../I18N";
import { CheckResult, TestBox } from "../index";
import "./testResultList.scss";

const TestResultList = ({
  results,
  title,
  firstColTitle,
  handleReTest,
  hasStatus = true
}) => {
  const { error, isLoading } = results;
  return (
    <TestBox
      testName={title}
      handleReTest={handleReTest}
      error={error}
      isLoading={isLoading}
    >
      <ul className="test-results-list">
        <li className={`test-results-list__item ${hasStatus ? '' : 'test-results-list__item--one-column'}`}>
          <span>{firstColTitle}</span>
          {hasStatus && <span>{I18N.t("STATUS")}</span>}
        </li>
        {results &&
          Object.keys(results).map(item => (
            <li key={item} className={`test-results-list__item ${hasStatus ? '' : 'test-results-list__item--one-column'}`}>
              <span>{item}</span>
              {hasStatus && <CheckResult isSuccess={results[item]} />}
            </li>
          ))}
      </ul>
    </TestBox>
  );
};

TestResultList.propTypes = {
  results: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  firstColTitle: PropTypes.string,
  handleReTest: PropTypes.func.isRequired
};
TestResultList.defaultProps = {
  firstColTitle: ""
};

export default TestResultList;
